var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishRestReturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.762L7.2 7.962V12.6C7.2 13.926 8.274 15 9.6 15H13.2C13.5 15 13.8 14.934 14.064 14.826L15.438 16.2H6V17.4H16.638L17.232 18L18 17.232L6.762 6L6 6.762ZM9.6 13.8C8.94 13.8 8.4 13.26 8.4 12.6V9.162L13.038 13.8H9.6ZM16.8 6.6H8.886L10.086 7.8H14.4V12.114L15.51 13.224C15.564 13.02 15.6 12.816 15.6 12.6V10.8H16.8C17.46 10.8 18 10.26 18 9.6V7.8C18 7.14 17.46 6.6 16.8 6.6ZM16.8 9.6H15.6V7.8H16.8V9.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishRestReturn);
export default __webpack_public_path__ + "static/media/FinishRestReturn.a1d86b756171fd042d8ab7dbdf5cc1f4.svg";
export { ForwardRef as ReactComponent };